import { IncidentsGridBaseDataProvider } from './IncidentsGridBaseDataProvider';
import { IncidentsGridWebComponentSchema } from '../types';

export class IncidentsGridNirvanaDataProvider extends IncidentsGridBaseDataProvider {
  async getDataForView(): Promise<IncidentsGridWebComponentSchema> {
    return {
      availableUsers:
        await this.dependencies.api.clients.UnifiedIncidents.getAvailableUsersForAssigneeFilter().toPromise(),
    };
  }
}
